// src/components/SentryRouteTags.tsx
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Sentry } from "../../../config/sentry";

export default function SentryRouteTags() {
  const { pathname } = useLocation();

  useEffect(() => {
    // map route -> microservice tag
    const map: Record<string, string> = {
      "/pdftotxt": "pdftotxt",
      "/p7mpage": "p7m",
      "/DoCompare": "doc-compare",
    };

    Sentry.setTag("route", pathname);
    Sentry.setTag("microservice", map[pathname] ?? "other");
  }, [pathname]);

  return null;
}
